// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3YDQe","left":"InfoRow_left__rTg3x"};